class StickyBanner {
	init() {
		if (bi_ad_settings.is_sticky_banner) {
			this.setSticky();
		}
	}

	setSticky() {
		const billboard = jQuery('.superbanner-container')[0];
		let firedOnce = false;

		window.onscroll = function () {
			if (!bi_ad_settings.is_sticky_banner) {
				return;
			}

			// Check if ad is delivered
			if (jQuery('.bi-superbanner').find('.addelivered').length !== 0) {
				if (
					(document.body.scrollTop > 0 && firedOnce === false) ||
					(document.documentElement.scrollTop > 0 && firedOnce === false)
				) {
					// Set firedOnce to stop the function from repeating
					firedOnce = true;

					// Prevent "jumping" of content by creating extra space element when ad becomes sticky
					const adTopSpace = document.createElement('div');
					adTopSpace.className = 'ad-top-space';
					adTopSpace.style.height = billboard.offsetHeight + 'px';
					billboard.parentNode.insertBefore(adTopSpace, billboard.nextSibling);

					// Make it sticky
					billboard.classList.add('sticky-ad');

					// Set background-color to same color as body element
					jQuery('.bi-superbanner').css(
						'background-color',
						jQuery('body').css('backgroundColor'),
					);
					setTimeout(function () {
						// Return to normal
						billboard.classList.remove('sticky-ad');
						adTopSpace.remove();
						jQuery('.bi-superbanner').css('background-color', 'inherit');
					}, 2250);
				}
			}
		};
	}
}

const instance = new StickyBanner();
export default instance;
